/**
 * Keeps only vendor rows whose period range exists in the supported list.
 * @param {Array<{period: {lower: string, upper: string}}>} items
 * @param {Array<{lower: string, upper: string}>} supportedPeriods
 * @returns {Array<Object>}
 */
export const filterVendorsBySupportedPeriods = (items, supportedPeriods) => {
   return items.filter((item) =>
      supportedPeriods.some(
         (period) => item.period.lower === period.lower && item.period.upper === period.upper
      )
   );
};
